import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

const Wrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    padding: ${theme.spacing(2)};
    z-index: 999999;
    ${theme.media('sm')} {{
      padding: ${theme.spacing(5)};
    }
  `}
`

const Backdrop = styled(motion.div)`
  ${({ theme }) => css`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: ${theme.spacing(5)};
    background-color: rgba(0, 0, 0, 0.5);
    transition: background-color 200ms ease-in-out;
    will-change: background-color;

    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.7);
    }
  `}
`

const Dialog = styled(motion.div)<{ $maxWidth: number | string }>`
  ${({ $maxWidth }) => css`
    position: relative;
    background-color: white;
    border-radius: 0.4rem;
    max-width: ${typeof $maxWidth === 'number' ? `${$maxWidth}rem` : $maxWidth};
  `}
`

export default {
  Wrapper,
  Backdrop,
  Dialog,
}
